import React, { useEffect, useState } from 'react';

const DeviceChecker = () => {
  const [deviceId, setDeviceId] = useState('');

  useEffect(() => {
    const generateDeviceId = () => {
      const userAgent = navigator.userAgent;
      const screenResolution = `${window.screen.width}x${window.screen.height}`;
      const deviceInfo = `${userAgent}-${screenResolution}`;
      setDeviceId(deviceInfo);
    };

    generateDeviceId();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Your Device ID</h2>
      <p style={{ wordBreak: 'break-all' }}>{deviceId}</p>
      <button onClick={() => navigator.clipboard.writeText(deviceId)}>
        Copy Device ID
      </button>
    </div>
  );
};

export default DeviceChecker;